module.exports = __webpack_public_path__ + "img/honeybee.8515f32a.gif";